export default {
    selectedAppSettingModel: {},
    selectAppSettingLoading: false
}